<template>
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div class="body-wrap">
        <div class="update-btn-wrap">
          <div v-if="getSoftwareStatus === 3" class="dot"></div>
          <cus-button color="gray-noFocus" text="軟體更新" @click="updateSoftware"></cus-button>
        </div>
        <cus-button color="gray-noFocus" text="商品資料更新" @click="updatePosData"></cus-button>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="返回" color="blue" @click="close"></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>
</template>

<script>
import { inject } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { handleUpgradeStatus } from '@/utils/upgrade';
import { openUpdateConfirm } from '@/utils/updatePosData';

export default {
  name: 'updating',
  setup() {
    // 接受provide值
    const close = inject('inner_close');

    //軟體更新
    const getSoftwareStatus = useGetters('upgrade', ['getSoftwareStatus']);
    const updateSoftware = () => {
      handleUpgradeStatus(getSoftwareStatus.value);
      close();
    };

    //商品資料更新
    const checkPosDataStatus = useActions('updatePosData', ['checkPosDataStatus']);
    const updatePosData = async () => {
      await checkPosDataStatus();
      openUpdateConfirm();
      close();
    };

    return {
      close,
      getSoftwareStatus,
      updateSoftware,
      updatePosData,
    };
  },
};
</script>

<style lang="scss" scoped>
.body-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 120px);
  grid-gap: 8px;
  padding: 0 4px;
}
.update-btn-wrap {
  display: flex;
  position: relative;
  .dot {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: $color-yellow;
  }
}
</style>
